export default "__VITE_ASSET__dcf7dff5__"